import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { Field } from '@/core/uql';

interface ShiftAtomSoufflingBottlingState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    souffling_list: any[];
    shift_souffling_list: any[];
    plan_list: any[];
    schemas: any;
}

const state: ShiftAtomSoufflingBottlingState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    souffling_list: [],
    shift_souffling_list: [],
    plan_list: [],
    schemas: {}
};

const initState: any = cloneDeep(state);

const GET_PLAN_LINES_LIST = 'GET_PLAN_LINES_LIST';
const GET_LINES_SOUFFLING_LIST = 'GET_LINES_SOUFFLING_LIST';
const GET_SHIFT_SOUFFLING_LIST = 'GET_SHIFT_SOUFFLING_LIST';


export const actions: ActionTree<ShiftAtomSoufflingBottlingState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, lineId, type }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;

        return new Promise((resolve, reject) => {
          vm.$db([
            vm.$q('SCHEMA_SFV')
                .raw('schemas.get')
                .action({
                    id: `s:shift_fact_vdp`
                }),
            vm.$q('SCHEMA_SJV')
                .raw('schemas.get')
                .action({
                    id: `s:shift_journal_vdp`
                }),
            vm.$q(GET_LINES_SOUFFLING_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'vls.id',
                  text: 'vls.text',
                  with_button: 'vls.with_button',
                  button_label: 'vls.button_label',
                  field_taget: 'vlsf.target',
                  field_type: 'vlsf.type',
                  field_label: 'vlsf.label',
                  field_id: 'vlsf.id',
                },
                from: 's:voc_lines_souffling',
                from_as: 'vls',
                joins: [
                  {
                    join: 's:voc_lines_souffling_fields',
                    type: 'left',
                    as:   'vlsf',
                    on: {
                      $eq: ['vls.field_id', 'vlsf.id']
                    }
                  },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['vls.position']},
                  {$asc: ['vls.id']}
                ],
                where: {
                  $and: [
                    {$eq: [`vls.line_id`, {$: lineId}]},
                    {$eq: [`vls.type`, {$: 'bolling'}]},
                  ]
                }
              }),
            vm.$q(GET_PLAN_LINES_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sacp.id',
                  shift_id: 'sacp.shift_id',
                  number: 'sacp.number',
                  base_name: 'p.name',
                  // base_name: {$concat: ['base.name', {$: ' '}, 'vst.name']},
                  // done_delay: 'base.done_delay',
                  // fact_id: 'sfv.id',
                  // is_done: 'sfv.is_done',
                  // done_time: 'sfv.done_time',
                  // frozen_time: 'sjv.frozen_time',
                  // is_prev: {$not: [{$eq: [`spv.shift_id`, {$: documentId}]}]},
                  // ignore_done_delay: 'spv.ignore_done_delay'
                },
                from: 's:shift_atom',
                from_as: 'sacp',
                joins: [
                  // {
                  //   join: 's:produced_products',
                  //   type: 'left',
                  //   as:   'pp',
                  //   on: {
                  //     $eq: ['sacp.product_id', 'pp.id']
                  //   }
                  // },
                  {
                    join: 's:products',
                    type: 'left',
                    as:   'p',
                    on: {
                      $eq: ['sacp.product_id', 'p.id']
                    }
                  },
                  // {
                  //   join: 's:voc_starter_types',
                  //   type: 'left',
                  //   as:   'vst',
                  //   on: {
                  //     $eq: ['vst.id', 'spv.starter_type_id']
                  //   }
                  // },
                  // {
                  //   join: 's:shift_fact_vdp',
                  //   type: 'left',
                  //   as:   'sfv',
                  //   on: {
                  //     $eq: ['sfv.shift_plan_id', 'spv.id']
                  //   }
                  // },
                  // {
                  //   join: 's:shift_journal_atom',
                  //   type: 'left',
                  //   as:   'sja',
                  //   on: {
                  //     $eq: ['sja.plan_id', 'sacp.id']
                  //   }
                  // },
                  // {
                  //   join: {
                  //     columns: {
                  //       id: 'base.id',
                  //     },
                  //     from: 's:shifts',
                  //     from_as: 's',
                  //     joins: [
                  //       {
                  //         join: 's:shifts',
                  //         type: 'left',
                  //         as:   'base',
                  //         on: {
                  //           $and: [
                  //             { $lt: ['base.real_end_time', 's.real_begin_time']},
                  //             { $eq: ['base.line_id', 's.line_id']},
                  //             { $not: [ { $null: [`base.real_end_time`] } ] }
                  //           ]
                  //         }
                  //       },
                  //     ],
                  //     where: {
                  //       $eq: [`s.id`, {$: documentId}]
                  //     },
                  //     order: [
                  //       {$desc: ['base.real_end_time']}
                  //     ],
                  //     page: 0,
                  //     page_size: 1
                  //   },
                  //   type: 'left',
                  //   as: 'prev_spv',
                  //   on: { $eq: ['spv.shift_id', 'prev_spv.id'] }
                  // },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['sacp.id']}
                ],
                groups: [
                  'sacp.id',
                  'sacp.shift_id',
                  'sacp.number',
                  'p.name',
                ],
                where: {
                  $and: [
                    {$or: [
                      {$eq: [`sacp.shift_id`, {$: documentId}]},
                      // {$not: [ { $null: [`prev_spv.id`] } ]},
                    ]},
                    // {$null: ['sacp.deleted_at']}
                  ],
                }
              }),
            vm.$q(GET_SHIFT_SOUFFLING_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'ss.id',
                  souffling_id: 'ss.souffling_id',
                  shift_plan_id: 'ss.shift_atom_plan_id',
                  is_accepted: 'ss.is_accepted',
                  manager_name: 'employee.name',
                  updated_at: 'ss.updated_at',
                },
                from: 's:shift_souffling',
                from_as: 'ss',
                joins: [
                  {
                    join: 's:employees',
                    type: 'left',
                    as:   'employee',
                    on: {
                      $eq: ['employee.id', 'ss.manager_id']
                    }
                  },
                  {
                    join: {
                      columns: {
                        id: 'base.id',
                      },
                      from: 's:shifts',
                      from_as: 's',
                      joins: [
                        {
                          join: 's:shifts',
                          type: 'left',
                          as:   'base',
                          on: {
                            $and: [
                              { $lt: ['base.real_end_time', 's.real_begin_time']},
                              { $eq: ['base.line_id', 's.line_id']},
                              { $not: [ { $null: [`base.real_end_time`] } ] }
                            ]
                          }
                        },
                      ],
                      where: {
                        $eq: [`s.id`, {$: documentId}]
                      },
                      order: [
                        {$desc: ['base.real_end_time']}
                      ],
                      page: 0,
                      page_size: 1
                    },
                    type: 'left',
                    as: 'prev_spv',
                    on: { $eq: ['ss.shift_id', 'prev_spv.id'] }
                  },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['ss.id']}
                ],
                where: {
                  $or: [
                    {$eq: [`ss.shift_id`, {$: documentId}]},
                    {$not: [ { $null: [`prev_spv.id`] } ]},
                  ],
                }
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(GET_LINES_SOUFFLING_LIST);
            const opListResult = result.getOperation(GET_SHIFT_SOUFFLING_LIST);
            const opPlanListResult = result.getOperation(GET_PLAN_LINES_LIST);

            const groupsByNumber = opPlanListResult.getContent().documents.reduce((prev: any, item: any) => {
              if (item.number) {
                const _key = item.number.split('.')[0] + '-' + item.shift_id;
                if (!prev[_key]) {
                  prev[_key] = []
                }
                prev[_key].push(item.id)
              }
              return prev
            }, {})

            const planList = opPlanListResult.getContent().documents.map((item: any) => {
              const _key = item.number.split('.')[0] + '-' + item.shift_id;
              item.plans = groupsByNumber[_key];
              return item;
            }).filter((item: any) => {
              return item.number.split('.').length == 1
            })

            if (!opRelResult.hasError() && !opRelResult.hasError()) {
              state.shift_souffling_list = opListResult.getContent().documents
              state.plan_list = planList
              state.schemas.shift_fact_vdp = result.getOperation('SCHEMA_SFV').getContent().schema
              state.schemas.shift_journal_vdp = result.getOperation('SCHEMA_SJV').getContent().schema

              const shift_souffling: any = {}
              state.shift_souffling_list.map((item: any) => {
                if (!shift_souffling[item.shift_plan_id]) {
                  shift_souffling[item.shift_plan_id] = {}
                }
                shift_souffling[item.shift_plan_id][item.souffling_id] = item
              })
              state.souffling_list = planList.reduce((prev: any, plan: any) => {
                prev[plan.id] = opRelResult.getContent().documents.map((item: any) => {
                  const _new_item = cloneDeep(item)
                  if (shift_souffling[plan.id] && shift_souffling[plan.id][_new_item.id]) {
                    _new_item.shift_souffling = shift_souffling[plan.id][_new_item.id]
                  }
                  _new_item.shift_plan_id = plan.id
                  _new_item.plans = plan.plans
                  _new_item.value = null
                  _new_item.message = ''
                  return cloneDeep(_new_item)
                })
                return prev
              }, {})
            }
            resolve(null);
          });
        })
    },

    setAccepted({state, dispatch, commit, rootState}, {documentId, item, plan}) {
      const vm = (this as any)._vm;
      return new Promise((resolve, reject) => {
        commit('START_LOADING');
        let saveQuery = null;
        if (item.shift_souffling) {
            saveQuery = vm.$q('SHIFT_DATA_SAVE')
                .update(item.shift_souffling.id, {
                  is_accepted: true,
                  manager_id: (rootState as any).ubic.actor.document.id
                })
        } else {
            saveQuery = vm.$q('SHIFT_DATA_SAVE')
                .create('s:shift_souffling', {
                  shift_id: documentId,
                  souffling_id: item.id,
                  shift_atom_plan_id: item.shift_plan_id,
                  is_accepted: true,
                  manager_id: (rootState as any).ubic.actor.document.id
                })
        }
        const queries = [];
        let field_name: any = null;
        if (item.field_taget) {
          field_name = item.field_taget.field_name;
          if (!['acidity_1', 'acidity_2', 'acidity_3', 'acidity_4'].includes(item.field_taget.field_name)) {
            queries.push(saveQuery)
          } else if (item.field_taget.field_name == 'acidity_4' || plan.target_acidity <= item.value) {
            queries.push(saveQuery)
          }
        }  else {
          queries.push(saveQuery)
        }

        if (item.field_id) {
          item.plans.map((plan_id: any) => {
            queries.push(
              vm.$q("SET_SOUFFLINGVALUE-"+plan_id)
                .raw('set_atom_soufling_value')
                .action({
                  field_id: item.field_id,
                  shift_atom_coock_plan_id: plan_id,
                  shift_id: documentId,
                  value: item.value,
                  field_name: field_name,
                })
            )
          })
        }

        vm.$db(queries).then((result: ServerResult) => {
          resolve(null)
          commit('LOADED_SUCCESS');
        });
      })
    },

    setDone({state, commit}, {plan}) {
      console.log(plan)
      const vm = (this as any)._vm;
      return new Promise((resolve, reject) => {
        let done_time = moment(plan.frozen_time)

        if (plan.ignore_done_delay) {
          done_time = done_time.add(plan.done_delay.secs, 'seconds');
        }

        const queries: any[] = [
          vm.$q('SHIFT_DATA_SAVE')
                .update(plan.fact_id, {
                  is_done: true,
                  done_time: done_time.utc().local().format('YYYY-MM-DD HH:mm:ss')
                })
        ];
        commit('START_LOADING');
        vm.$db(queries).then((result: ServerResult) => {
          resolve(null)
          commit('LOADED_SUCCESS');
        });
      })

    },

    setItemValue({state, commit}, {plan_id, index, newValue}) {
      commit('SET_ITEM_VALUE', {plan_id, index, newValue})
    }
};

export const mutations: MutationTree<ShiftAtomSoufflingBottlingState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  SET_ITEM_VALUE: (state, {plan_id, index, newValue}) => {
    console.log('SET_ITEM_VALUE', state.souffling_list[plan_id], plan_id, index, newValue)
    state.souffling_list[plan_id][index].value = newValue
  }
};

export const getters: GetterTree<ShiftAtomSoufflingBottlingState, RootState> = {
  shift_souffling_list: (state: ShiftAtomSoufflingBottlingState) => {
    const shift_souffling: any = {}
    state.shift_souffling_list.map((item: any) => {
      shift_souffling[item.souffling_id] = item
    })

    return state.souffling_list.map((item: any) => {
      if (shift_souffling[item.id]) {
        item.shift_souffling = shift_souffling[item.id]
      }
      return item
    })
  }
};

export const STORE_KEY = '$_shift_atom_souffling_bottling_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
